import PropTypes from 'prop-types';
import { Typography, Stack, Box } from '@mui/material';
import Markdown from '../../../../reusable-components/markdown';
import FileThumbnail from '../../../../reusable-components/file-thumbnail';
import { stringToColor } from '../../../../utils/cssStyles';
import { fMonthDayTimeYear, convertToUnix } from '../../../../utils/formatTime';
import { useTabs } from '../../../../context/TabContext';
import { cleanMailTo, replaceLinks } from '../../../../reusable-components/markdown/markdown-cleanup';

OrderNotesItem.propTypes = {
  message: PropTypes.object,
  previousMessage: PropTypes.object,
  onOpenLightbox: PropTypes.func,
  index: PropTypes.number,
};

export default function OrderNotesItem({ message, previousMessage, onOpenLightbox, index }) {
  const { addNewTabAndNavigate } = useTabs();
  const { file, fullName, id, note, sentOn, sentBy } = message;
  const name = fullName || sentBy;
  const previousMsgName = previousMessage?.fullName || previousMessage?.sentBy;
  const removeDetails = previousMessage &&  previousMsgName === name && convertToUnix(sentOn) - convertToUnix(previousMessage?.sentOn) < 120000;

  const getTicketFile = () => window.open(`Api/TicketFile?noteId=${id}`, '_blank');
  const sameSite = (url) => url.includes('localhost:44475/') || url.includes('app.platformsolutions.com');

  return <Box justifyContent="flex-start" sx={{ mt: removeDetails ? 0.5 : 2 }} key={index}>
    <Stack alignItems={'flex-start'}>
      {removeDetails ? null : <>
        <Typography noWrap variant="caption">
          {name || sentBy},
        </Typography>
        <Typography noWrap variant="caption" sx={{ color: 'text.disabled' }}>
          {fMonthDayTimeYear(message.sentOn)}
        </Typography>
      </>}
      {file ? <Box sx={{ width: 46, height: 46, borderRadius: 1, overflow: 'hidden', position: 'relative', backgroundColor: 'background.neutral' }}>
        <FileThumbnail
          file={note}
          tooltip
          onDownload={getTicketFile}
          sx={{ width: 46, height: 46 }}
          onImageView={() => onOpenLightbox(`/api/TicketFile?noteId=${id}`)}
          preview={`/api/TicketFile?noteId=${id}`}
        />
      </Box> : <Box
          sx={{
            p: 1,
            width: '100%',
            borderRadius: '9px',
            wordWrap: 'break-word',
            typography: 'body2',
            border: `solid 1px ${stringToColor(name)}`,
            display: 'inline-block',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}
      >
        <Box
          onClick={(event) => {
            if (event.target.tagName === 'A') {
              event.preventDefault();
              if (sameSite(event.target.href)) addNewTabAndNavigate(event.target.href);
              else window.open(event.target.href, '_blank');
            }
            if (event.target.tagName === 'IMG') onOpenLightbox(event.target.src);
          }}
          sx={{ '& img': { cursor: 'pointer', '&:hover': { filter: 'brightness(0.9)', padding: 0.3, border: `solid 1px ${stringToColor(name)}` } } }}
        >
          <Markdown children={cleanMailTo(replaceLinks(note))} />
        </Box>
      </Box>}
    </Stack>
  </Box>;
}
